import defaultDialogTemplate from '_mustache/components/dialog.mustache';
import mustache from 'mustache';

import '_tradeholding/scss/components/dialog.scss';

class ModalDialog {

    constructor(options, template) {
        if (typeof template == 'undefined') this.__setDefaultTemplate();
        else this.template = template;
        
        this.options = options;
        this.dom = {
            main: null
        }

        this.__init(options);
    }

    /** Set the default template for the dialog
     * 
     */
    __setDefaultTemplate() {
        this.template = defaultDialogTemplate;
    }

    /** Init and open the dialog
     * 
     */
    __init(options) {
        let selfRef = this,
            buttonIterator,
            iteratedButton;

        this.options = jQuery.extend(true, {
            attach: 'body',
            type: 'default-dialog',
            closable: true,
            title: false,
            content: '',
            onshown: false,
            ondestroy: false,
            destroyed: false,
            buttons: []
        }, options);

        for (buttonIterator in this.options.buttons) {
            if (typeof this.options.buttons[buttonIterator].id == 'undefined') this.options.buttons[buttonIterator].id = utils.default.uniqid();
        }

        this.dom.main = jQuery(mustache.render(this.template, this.options)).addClass('appearing');
        this.dom.dialogBox = this.dom.main.find('.dialog-box');
        this.dom.container = jQuery(this.options.attach);
        this.dom.buttons = [];

        if (this.dom.container.length == 0) return;
        this.dom.container.append(this.dom.main);
        this.dom.main.hide().show();

        for (buttonIterator in this.options.buttons) {
            iteratedButton = this.dom.main.find('button#' + this.options.buttons[buttonIterator].id);

            if (typeof this.options.buttons[buttonIterator].action == 'function') {
                (function(buttonData, iteratedButton) {
                    iteratedButton.on('click', function() {
                        buttonData.action.apply(selfRef, [selfRef]);
                    });
                })(this.options.buttons[buttonIterator], iteratedButton);
            }
        }

         
        this.dom.dialogBox.one('animationend', function (event) {
            if (typeof selfRef.options.onshown == 'function') selfRef.options.onshown.apply(selfRef, [selfRef]);
            selfRef.dom.main.removeClass('appearing');
            selfRef.dom.main.find('.closer-cta, .overlay').on('click', function() {
                selfRef.close();
            });
        });
        
    }

    /** Close the dialog box and destroy it
     * 
     */
    close() {
        let selfRef = this,
            allowDestroy = true;

        if (typeof this.options.ondestroy == 'function') allowDestroy = this.options.ondestroy.apply(selfRef, []);
        if (allowDestroy) {
            this.dom.dialogBox.one('animationend', function (event) {
                if (typeof selfRef.options.destroyed == 'function') selfRef.options.destroyed.apply(selfRef, []);
                selfRef.dom.main.remove();
                event.preventDefault();
                event.stopPropagation();
            });

            this.dom.main.addClass('destroying');
        }
    }

    static show(options) {
        if (typeof options.cssClass == 'undefined') options.cssClass = 'tradeholding-dialog';
        else options.cssClass+=" tradeholding-dialog";

        super.show(options);
    }
}

export default ModalDialog;